<template>
  <div class="w-full bg-white">
    <p
      v-if="favoriteServicesStore.favorites.length === 0"
      class="px-2 py-1.5 text-xs ltr:font-sans"
    >
      {{ $t('noServices') }}
    </p>
    <div
      v-else
      class="p-3 w-full h-[32rem] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 overflow-y-auto"
    >
      <ServiceCardVue
        :key="key"
        :label="service.serviceName"
        :service-id="service.serviceTransId"
        v-tippy="{ content: service.serviceTransactionDescription.serviceFullDescription }"
        v-for="(service, key) in favoriteServicesStore.favorites"
      >
        <template #serviceCard>
          <FavoriteButton
            :is-favorited="true"
            @on-click="favoriteServicesStore.toggleFavoriteStatus(service)"
          />
        </template>
        <template #footer>
          <div class="w-full flex justify-between">
            <StartButton :service="service" label-class="pe-1 ps-0.5 text-[10px]" />
            <OpenServicecardButton
              :service="{ ...service, transactionId: service.serviceTransId }"
              label-class="ps-1 pe-0.5 text-[10px]"
            />
          </div>
        </template>
      </ServiceCardVue>
    </div>
  </div>
</template>

<script setup>
import FavoriteButton from '@/components/Buttons/Service/FavoriteButton.vue'
import OpenServicecardButton from '@/components/Buttons/Service/OpenServicecard.vue'
import StartButton from '@/components/Buttons/Service/StartButton.vue'
import ServiceCardVue from '@/components/cards/ServiceCard.vue'
import { useFavoriteService } from '@/stores/favorite_services.js'
import { onMounted } from 'vue'

const favoriteServicesStore = useFavoriteService()

onMounted(async () => {
  await favoriteServicesStore.fetchFavorites()
})
</script>

<style lang="scss" scoped></style>
